var $body = $("body");
var $favContainer = $("header").find("#favourites-container");
var $close = $favContainer.find(".close-slide");
var $cartToggle = $(".cart");
var $cartContainer = $("header").find("#cart-container");
var $addToCart = $(".add-to-cart");
var $addToCartQuantity = $(".add-to-cart-quantity");

$close.on("click", function () {
  "use strict";
  if ($favContainer.hasClass("show")) {
    $favContainer.removeClass("show");
  }
  if ($body.hasClass("overlay")) {
    $body.removeClass("overlay");
  }
});

var $closeCart = $cartContainer.find(".close-slide");
$closeCart.on("click", function () {
  "use strict";
  if ($cartContainer.hasClass("show")) {
    $cartContainer.removeClass("show");
  }
  if ($body.hasClass("overlay")) {
    $body.removeClass("overlay");
  }
});

var $accordionToggle = $("#accordionDelivery .card .card-header").find(
  ".toggle"
);
var $radioButtonCheck = $accordionToggle.find(".radio-button > .radio-inner");
$accordionToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheck.removeClass("checked");
  if ($radioButtonCheck.hasClass("checked")) {
    $radioButtonCheck.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $accordionPaymentToggle = $("#accordionPayment .card .card-header").find(
  ".toggle"
);
var $radioButtonCheckPayment = $accordionPaymentToggle.find(
  ".radio-button > .radio-inner"
);
$accordionPaymentToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheckPayment.removeClass("checked");
  if ($radioButtonCheckPayment.hasClass("checked")) {
    $radioButtonCheckPayment.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $paymentToggle = $("#checkout").find(".payment-toggle");
var $paymentContainer = $("#checkout").find("#order-details");
$paymentToggle.on("click", function () {
  $(this).toggleClass("toggle");
  $paymentContainer.toggleClass("expanded");
  $body.toggleClass("overflow-hidden");
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

var Cart = function (container, type) {
  this._body = $("body");
  this._addButton = $(".add-to-cart-button");
  this._addQuantityInput = $(".add-to-cart-quantity");
  this._addOptions = $(".product-options");
      this._cartContainer = container;
      this._type = type;
      this.initialize();
};
Cart.prototype = {
  _body: null,
  _addButton: null,
  _addOptions: null,
  _addQuantityInput: null,
  _changeTimeout: null,
  _changeRequest: null,
  _cartContainer: null,
  _type: null,
    initialize: function () {
      var self = this;

      if (this._type == "full") {
        var fullCartUrl = "/cart/cart?type=full";

        if (window.location.search.indexOf("checkout_blocked=1") !== -1) {
          fullCartUrl += "&checkout_blocked=1";
        }

        $.get(fullCartUrl, {}, function (html) {
        self.openWithHTML(html);
        productList.getPrices();
      });
    }
    if (this._type == "side") {
      this._addButton.on("click", function () {
        var options = [];

        if (self._addOptions.length > 0) {
          var valid = true;
          self._addOptions.each(function () {
            if ($(this).find("input:checked").val() != null) {
              options.push($(this).find("input:checked").val());
            } else {
              $(this).addClass("error");
              valid = false;
            }
          });

          if (!valid) {
            return false;
          }
        }

        var button = $(this);


        if (button.closest("#products-list").length > 0) {
          var id = button.closest(".product-single").find(".productVariants").length > 0 ? button.closest(".product-single").find(".productVariants").val() : button.data("id");
          var qty = button.closest(".product-single").find(".add-to-cart-quantity").val();
        } else {
          var id = $(this).data("id");
          var qty = button.closest(".product").find(self._addQuantityInput);
          qty = qty.length == 0 ? 1 : qty.val();
        }

        $.post("/cart/add", {
          id: id,
          qty: qty,
          options: options,
          mobile: button.hasClass("add-to-cart-mobile"),
        })
          .done(function (html) {
            //$("#addToCartPopup").html(html).modal();
            getStatus();
          })
          .fail(function (xhr, status, error) {
            $(".stock-alert").removeClass("max-stock-limit");
            $(".stock-alert-cart").addClass("max-stock-limit");
          });

        return false;
      });

      self._body.find(".side-cart-overlay").on("click", function () {
        self._body.removeClass("overlay");
        self._cartContainer.removeClass("show");
      });
    }
  },

  openWithHTML: function (html) {
    var self = this;

    if (this._type == "side") {
      self._body.addClass("overlay");
    }
    self._cartContainer.html(html).addClass("show");

    self._cartContainer.find(".close-slide").on("click", function () {
      self._body.removeClass("overlay");
      self._cartContainer.removeClass("show");
    });

    self._cartContainer.find(".remove-button").on("click", function () {
      var product = $(this).parents(".product");
      if (product.hasClass("is-package-item")) {
        return false;
      }

      var options =
        product.data("options") == "" ? [] : product.data("options").split(";");

      self.change(
        "remove",
        {
          id: product.data("id"),
          options: options,
        },
        $(this)
      );

      return false;
    });

    self._cartContainer.find(".btn-plus").on("click", function () {
      var product = $(this).parents(".product");
      if (product.hasClass("is-package-item")) {
        return false;
      }
      var qty = product.find(".qty");

      // var stock = $(this).data("stock");
      // if (stock <= parseInt(qty.val())) {
      //   $(".stock-alert").addClass("max-stock-limit");
      //   return;
      // } else {
      //   $(".stock-alert").removeClass("max-stock-limit");
      // }

      qty.val(parseInt(qty.val()) + 1).trigger("blur");
    });

    self._cartContainer.find(".btn-minus").on("click", function () {
      var product = $(this).parents(".product");
      if (product.hasClass("is-package-item")) {
        return false;
      }
      var qty = product.find(".qty");

      qty.val(parseInt(qty.val() - 1)).trigger("blur");

      return false;
    });

    self._cartContainer.find(".qty").on("blur", function () {
      var product = $(this).parents(".product");
      if (product.hasClass("is-package-item")) {
        return false;
      }

      var options =
        product.data("options") == "" ? [] : product.data("options").split(";");

      self.change(
        "qty",
        {
          id: product.data("id"),
          qty: product.find(".qty").val(),
          options: options,
        },
        $(this)
      );

      return false;
    });

    if (!self.executed) {
      self.executed = true;
      var contentIds = [];
      var contents = [];
      $(".cartfull-products-list .product").each(function () {
        contentIds.push($(this).data("productcode"));
        contents.push({
          id: $(this).data("productcode"),
          quantity: $(this).data("quantity"),
        });
      });
    }
  },
  change: function (action, data, element) {
    var self = this;

    if (self._changeRequest != null) {
      self._changeRequest.abort();
    }
    if (self._changeTimeout != null) {
      clearTimeout(self._changeTimeout);
    }

    self._changeTimeout = setTimeout(function () {
      element
        .parents(".product")
        .find(".quantity.input-group")
        .prepend('<div class="list-loader"><div class="inner"></div></div>');

      self._cartContainer.find(".cart-overlay").show();

      self._changeRequest = $.post(
        "/cart/" + action + "?type=" + self._type,
        data,
        function (html) {
          self.openWithHTML(html);

          getStatus();
        }
      );
    }, 600);
  },
};

var fullCartPlaceholder = $(".full-cart-placeholder");
var sideCartPlaceholder = $(".side-cart-placeholder");
if (fullCartPlaceholder.length > 0) {
  fullCartPlaceholder.prepend(
    '<div class="list-loader"><div class="inner"></div></div>'
  );
  new Cart(fullCartPlaceholder, "full");
} else {
  new Cart($(".side-cart-placeholder"), "side");
}

getStatus();

function getStatus() {
  $.get("/cart/status", function (response) {
    var data = JSON.parse(response);

    if (data.cart > 0) {
      $(".count-shop").addClass("active");
    } else {
      $(".count-shop").removeClass("active");
    }

    $(".count-shop")
      .show()
      .html(data.cart > 0 ? data.cart : "");
  });
}

function setCheckoutSummaryLoading(isLoading) {
  $(".checkout-summary-placeholder")
    .toggleClass("is-loading", isLoading)
    .attr("aria-busy", isLoading ? "true" : "false");
}

function hasSapId($element) {
  return $element.attr("data-sap-id-set") === "true";
}

$(document).on("submit", "[data-checkout-form]", function (event) {
  var $form = $(this);

  if (!hasSapId($form.closest("[data-sap-id-set]"))) {
    event.preventDefault();
    $form.find("[aria-describedby=sap-id-checkout-notice]").focus();
  }
});

var $checkoutPage = $("#checkout[data-sap-id-set]");

if ($checkoutPage.length && !hasSapId($checkoutPage)) {
  var cartUrl = $checkoutPage.attr("data-cart-url") || "/kosarica";
  var separator = cartUrl.indexOf("?") === -1 ? "?" : "&";

  window.location.replace(cartUrl + separator + "checkout_blocked=1");
}

function refreshCheckoutSummary(html) {
  var $summary = $("<div>").html(html);

  $summary.find(".checkout-price-update").each(function () {
    var $update = $(this);
    var id = String($update.attr("data-id"));
    var options = $update.attr("data-options") || "";
    var $product = $(".order-products-list .product").filter(function () {
      return String($(this).attr("data-id")) === id && ($(this).attr("data-options") || "") === options;
    }).first();

    if (!$product.length) {
      return;
    }

    var originalPrice = $update.attr("data-original-price");
    var price = $update.attr("data-price");
    var priceHtml = $update.attr("data-has-discount") === "1"
      ? '<div class="user-price old-price">' + originalPrice + ' €</div><div class="user-sale-price">' + price + ' €</div>'
      : '<div class="user-price">' + originalPrice + ' €</div>';

    $product.find(".product-price .price").html(priceHtml);
  });

  $(".checkout-summary-placeholder").html($summary.find(".checkout-summary-card"));
  setCheckoutSummaryLoading(false);
  $(".free-delivery-container").toggleClass("show");
}

$(document).on("submit", ".checkout-coupon-form", function (event) {
  event.preventDefault();

  var $form = $(this);
  var $button = $form.find("button[type=submit]");
  if ($button.prop("disabled")) {
    return;
  }

  $button.prop("disabled", true).addClass("is-loading");
  setCheckoutSummaryLoading(true);
  $.post("/cart/checkout-coupon", { code: $form.find("[name=code]").val() })
    .done(refreshCheckoutSummary)
    .always(function () {
      $button.prop("disabled", false).removeClass("is-loading");
      setCheckoutSummaryLoading(false);
    });
});

$(document).on("click", ".coupon-remove", function (event) {
  event.preventDefault();

  var $button = $(this);
  if ($button.prop("disabled")) {
    return;
  }

  $button.prop("disabled", true).addClass("is-loading");
  setCheckoutSummaryLoading(true);
  $.post("/cart/checkout-coupon-remove")
    .done(refreshCheckoutSummary)
    .always(function () {
      $button.prop("disabled", false).removeClass("is-loading");
      setCheckoutSummaryLoading(false);
    });
});

var Checkout = function (container, type) {
  this.initialize();
};
Checkout.prototype = {
  initialize: function () {
    var self = this;

    let savedPayment = sessionStorage.getItem("payment_type_id");
    let savedDelivery = sessionStorage.getItem("delivery_type_id");
    let savedCountry = sessionStorage.getItem("billing_country_id");

    if (savedPayment)
      $("input[name=payment_type_id][value=" + savedPayment + "]").prop(
        "checked",
        true
      );
    if (savedDelivery)
      $("input[name=delivery_type_id][value=" + savedDelivery + "]").prop(
        "checked",
        true
      );
    if (savedCountry) $("select[name=billing_country_id]").val(savedCountry);

    if ($("#account-checkbox").is(":checked")) {
      $(".form-password").show().find("input").prop("required", true);
    }

    $("#account-checkbox").on("click", function () {
      if ($(this).is(":checked")) {
        $(".form-password").show().find("input").prop("required", true);
      } else {
        $(".form-password").hide().find("input").prop("required", false);
      }
    });

    $(".delivery-address").find("input").prop("required", false);
    $("#delivery-checkbox").on("click", function () {
      if ($(this).is(":checked")) {
        $(".delivery-address").show().find("input").prop("required", true);
        $("#create-new-delivery-address").prop("required", false);
      } else {
        $(".delivery-address").hide().find("input").prop("required", false);
      }
    });

    $("#delivery .form-check.pickup input[type=radio]").on(
      "change",
      function () {
        if ($(this).is(":checked")) {
          $(this).closest(".form-check.pickup").addClass("test");
          $("#delivery .form-check.address").removeClass("test");
          $(".delivery-address").hide().find("input").prop("required", false);

          $("#delivery-checkbox").prop("checked", false);
        }
      }
    );
    $("#delivery .form-check.address input[type=radio]").on(
      "change",
      function () {
        if ($(this).is(":checked")) {
          $(this).closest(".form-check.address").addClass("test");
          $("#delivery .form-check.pickup").removeClass("test");
        }
      }
    );

    $("#create-new-delivery-address").on("change", function () {
      const isChecked = $(this).is(":checked");
      $("#create-new-delivery-address-hidden").val(
        isChecked ? "true" : "false"
      );
    });

    $(".address-card").on("click", function () {
      $(".address-card.active.selected").removeClass(["active", "selected"]);

      $(this).addClass(["active", "selected"]);

      var address = $(this).data("address");

      $(".delivery-address input[name=delivery_address_id]").val(address.id);

      Object.keys(address).forEach(function (key) {
        $(".delivery-address input[name=delivery_" + key + "]").val(
          address[key]
        );
      });
    });

    self.saveDeliveryChoice(
      $("input[name=payment_type_id]:checked").val(),
      $("input[name=delivery_type_id]:checked").val(),
      $("select[name=billing_country_id]").val()
    );

    $("#delivery input, #payment input").on("change", function () {
      self.saveDeliveryChoice(
        $("input[name=payment_type_id]:checked").val(),
        $("input[name=delivery_type_id]:checked").val(),
        $("select[name=billing_country_id]").val()
      );
    });
  },

  saveDeliveryChoice: function (payment, delivery, country) {
    var self = this;
    sessionStorage.setItem("payment_type_id", payment);
    sessionStorage.setItem("delivery_type_id", delivery);
    sessionStorage.setItem("billing_country_id", country);
    setCheckoutSummaryLoading(true);
    $.post("/cart/checkout-delivery", {
      payment_type_id: payment != null ? payment : null,
      delivery_type_id: delivery != null ? delivery : null,
      country_id: country != null ? country : null,
    })
      .done(function (html) {
        self.applySummary(html);
      })
      .always(function () {
        setCheckoutSummaryLoading(false);
      });
  },
  applySummary: function (html) {
    refreshCheckoutSummary(html);
  },
};

if ($("#checkout").length > 0) {
  new Checkout();
}

var companyCheckbox = $(".personal").find("#company-checkbox");
var companyCont = $(".personal").find("#company");
companyCheckbox.on("click", function () {
  $(companyCont).toggleClass("show");
  var companyAddFields = $(companyCont).find("input[type=text]");
  $(companyAddFields).each(function (key, field) {
    $(field).attr("required", true);
  });
});

setTimeout(function () {
  if (companyCheckbox.is(":checked")) {
    $(companyCont).addClass("show");
  }
}, 500);

$("#notifications-checkbox").on("click", function () {
  $("#newsletter-mail").toggle();
});
